<template>
  <div id="app">
    <div id="navigation">
      <div class="menu" @click="toggleMenu">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <ul>
        <li><router-link to="/">LinguaWorks</router-link></li>
        <li @click="closeMenu" :class="{'show': menuVisible}"><router-link to="/resources">Language Resources</router-link></li>
        <li @click="closeMenu" :class="{'show': menuVisible}"><router-link to="/api">API Usage</router-link></li>
        <li @click="closeMenu" :class="{'show': menuVisible}"><router-link to="/transliterate">Transliterate Tool</router-link></li>
        <li @click="closeMenu" :class="{'show': menuVisible}"><router-link to="/contact">Contact Us</router-link></li>
      </ul>
    </div>

    <div id="body"><router-view/></div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      menuVisible: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    closeMenu() {
      this.menuVisible = false;
    }
  }
};
</script>


<style lang="scss">
@font-face {
  font-family: "Kaznet";
  src: url("./assets/fonts/kaznet.ttf") format("truetype");
}

@mixin for-phone-only {
  @media (max-width: 599px) {
    @content;
  }
}
@mixin for-tablet-portrait-up {
  @media (min-width: 600px) {
    @content;
  }
}
@mixin for-tablet-landscape-up {
  @media (min-width: 900px) {
    @content;
  }
}
@mixin for-desktop-up {
  @media (min-width: 1200px) {
    @content;
  }
}
@mixin for-big-desktop-up {
  @media (min-width: 1800px) {
    @content;
  }
}

$secondary_color: #084696;

html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  height: 100%;
  display: flex;
  flex-direction: column;

  min-height: 100vh;
  margin: 0 auto;
  max-width: 1440px;

  #body {
    padding: 25px;
    overflow-y: scroll;
    height: 100vh;

    @include for-phone-only() {
      padding: 10px;
    }
  }

  #navigation {
    width: 100%;
    flex-direction: horizontical;
    justify-content: space-between;
    padding: 1rem;
    text-align: right;
    background-color: #efefef;
    flex-shrink: 1;

    .menu {
      display: none;

      @include for-phone-only() {
        div {
          width: 30px;
          height: 4px;
          background-color: black;
          margin: 6px 0;
        }

        align-self: flex-end;
        display: initial;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }
    }

    ul {
      margin: 0;
      padding: 0;
      color: #000; /* Base text color for the menu */
      display: flex;
      flex-wrap: wrap;
      text-decoration: none;
      list-style-type: none;

      li {
        flex: 0 0 auto;

        &:nth-child(1) {
          margin-right: auto;

          a {
            font-size: 20px;
            &.router-link-exact-active {
              color: #2c3e50;
            }
          }

          &:after {
            content: "";
          }
        }

        &:after {
          content: "|"; /* Or go Facebook style and use "·" (the interpunct character) for separators */
          color: #666; /* You may want to make the separators a bit more subtle than the base text color */
        }

        &:last-child:after {
          content: "";
        }

        a {
          text-decoration: none;
          color: #2c3e50;
          margin: 0 8px; /* Set margins around the links */

          &.router-link-exact-active {
            color: #42b983;
          }
        }

        &:not(:first-child) {
          @include for-phone-only() {
            flex-basis: 100%;
            flex-direction: column;
            width: 100%;
            display: none;
            text-align: center;

            &.show {
              display: flex;
            }

            &:after {
              content: "";
            }
          }
        }
      }
    }
  }
}
</style>
